import React from "react";
import { Dropdown } from "primereact/dropdown";
import { useChartsStore } from "../../store/chartStore";
import timeOptions from "./timeOptions";
import useNavbarDropdown from "./useNavbarDropdown";

const PeriodicityDropdown = () => {
  const selectedChartId = useChartsStore(
    (state) => state.getSelectedChart()?.id || null,
  );
  const selectedChartPeriodicity = useChartsStore(
    (state) => state.getSelectedChart()?.periodicity || "1D",
  );
  const updateChartConfig = useChartsStore((state) => state.updateChartConfig);
  const fetchChartData = useChartsStore((state) => state.fetchChartData);
  const { dropdownRef, onShow, onHide } = useNavbarDropdown();

  const timeItemTemplate = (option) => (
    <div
      className={`flex align-items-center dropdown-item${option?.separator ? " periodicity-separator" : ""}`}
      style={{ border: "none", margin: 0, padding: "4px 8px" }}
    >
      {option?.label ?? option?.value}
    </div>
  );

  const handlePeriodicityChange = (e) => {
    updateChartConfig(selectedChartId, {
      periodicity: e.value,
      xExtents: null,
    });
    fetchChartData(selectedChartId);

    // Close the dropdown programmatically
    if (dropdownRef.current) {
      dropdownRef.current.hide();
    }
  };

  return (
    <Dropdown
      ref={dropdownRef}
      value={selectedChartPeriodicity}
      options={timeOptions}
      itemTemplate={timeItemTemplate}
      onChange={handlePeriodicityChange}
      onShow={onShow}
      onHide={onHide}
      placeholder="Período"
      className="time-dropdown no-scroll-dropdown navbar-button"
      appendTo={document.body}
      style={{
        width: "120px",
        textAlign: "left",
        display: "flex",
        alignItems: "center",
        border: "none",
        borderRadius: "0px",
      }}
      panelStyle={{
        minWidth: "120px",
        width: "160px",
      }}
      valueTemplate={(selected) => {
        if (!selected) return <div className="navbar-item-content" />;
        // selected can be a value or an option object depending on Dropdown configuration
        const selectedValue = selected?.value ?? selected;
        const opt = timeOptions.find((o) => o.value === selectedValue);
        return (
          <div className="navbar-item-content">
            <i className="pi pi-clock navbar-item-icon"></i>
            <span className="navbar-item-label">
              {opt?.label ?? selectedValue}
            </span>
          </div>
        );
      }}
      data-evo-id="navbar-periodicity-dropdown"
    />
  );
};

export default PeriodicityDropdown;
